"use client"

import styled from "@emotion/styled"
import { useRef } from "react"
import { Desktop, Mobile } from "ui"
import Container from "ui/Container"
import DynamicTitleRichText from "../Common/DynamicTitleRichText"
import HoursContactInfo from "./HoursContactInfo"
import StickyForm from "./StickyForm"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 64px;
    display: grid;
    grid-template-columns: 1fr 381px;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

type Props = {
  data: any
  locale: string
  formDynamicTextTooltip?: string
}

export default function CareerFormSection({
  data,
  formDynamicTextTooltip = "",
}: Props) {
  const contactUsData = data.contactUsData
  const isDriversPage = data.isDriversPage
  const formRef = useRef<HTMLDivElement>(null)

  const scrollToForm = () => {
    if (formRef.current) {
      const offset = 100
      const y =
        formRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        offset
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }

  return (
    <>
      <Container paddingMobile={true}>
        <StyledLayout>
          <StyledWrapper>
            <DynamicTitleRichText data={data} scrollToForm={scrollToForm} />
            {contactUsData && <HoursContactInfo data={contactUsData} />}
          </StyledWrapper>
          <Desktop>
            <StickyForm
              isDriversPage={isDriversPage}
              formRef={formRef}
              tooltipText={formDynamicTextTooltip}
            />
          </Desktop>
        </StyledLayout>
      </Container>
      <Mobile>
        <StickyForm
          isDriversPage={isDriversPage}
          formRef={formRef}
          tooltipText={formDynamicTextTooltip}
        />
      </Mobile>
    </>
  )
}
